import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, MessageSquarePlus, ArrowRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Props {
  modelId: string;
  brandSlug: string;
  modelSlug: string;
  modelName: string;
  brandName: string;
}

export function ModelCommunityCard({ modelId, brandSlug, modelSlug, modelName, brandName }: Props) {
  const [counts, setCounts] = useState<{ posts: number; experiences: number }>({ posts: 0, experiences: 0 });

  useEffect(() => {
    let alive = true;
    (async () => {
      const [{ count: posts }, { count: experiences }] = await Promise.all([
        supabase.from('community_posts').select('*', { count: 'exact', head: true }).eq('model_id', modelId).eq('is_hidden', false),
        supabase.from('car_experiences').select('*', { count: 'exact', head: true }).eq('model_id', modelId).eq('status', 'approved').eq('is_hidden', false),
      ]);
      if (alive) setCounts({ posts: posts || 0, experiences: experiences || 0 });
    })();
    return () => { alive = false; };
  }, [modelId]);

  const communityUrl = `/community/model/${brandSlug}/${modelSlug}`;
  const askUrl = `/community/sporgsmaal/nyt?model=${modelId}`;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Users className="w-5 h-5 text-accent" />
          Fællesskab om {brandName} {modelName}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Spørg ejere og eksperter, eller del din egen erfaring med denne model.
        </p>
        <div className="flex gap-3 text-sm">
          <span><strong>{counts.posts}</strong> spørgsmål</span>
          <span className="text-muted-foreground">·</span>
          <span><strong>{counts.experiences}</strong> erfaringer</span>
        </div>
        <div className="flex flex-col gap-2">
          <Link to={askUrl}>
            <Button variant="accent" className="w-full gap-2">
              <MessageSquarePlus className="w-4 h-4" />
              Stil et spørgsmål
            </Button>
          </Link>
          <Link to={communityUrl}>
            <Button variant="outline" className="w-full gap-2">
              Se alle indlæg
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
